<template>
  <fragment>
    <v-dialog
      class="rounded-xl base"
      persistent
      height="600"
      width="600"
      transition="dialog-bottom-transition"
      v-model="AddGuests"
    >
      <v-card width="100%" style="font-family: 'Archivo', sans-serif">
        <v-card-subtitle class="font-weight-bold pt-1 d-flex flex-row">
          <v-col>
            <span
              style="
                font-family: 'Archivo', sans-serif;
                font-size: 20px !important;
                font-weight: 600;
              "
            >
              Adicionar Convidados</span
            >
          </v-col>
          <v-col align="end" class="mr-n4">
            <v-btn icon @click="setOpenAddGuests" small>
              <v-icon class="mr-auto"> mdi-close-circle-outline </v-icon>
            </v-btn>
          </v-col>
        </v-card-subtitle>
        <v-container class="px-12">
          <v-form ref="form" @submit.prevent="sendForm" lazy-validation>
            <v-row>
              <v-col>
                <BaseTextarea
                  height="100"
                  label="E-mails"
                  v-model="convidados"
                  placeholder="Insira os e-mails dos convidados, separados por ponto-virgula (;) ou por vírgula (,)"
                  persistent-placeholder
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col>
                <v-checkbox
                  label="Enviar para Consumidores cadastrados na loja."
                  class="rounded-lg checkbox-layout justify-center pt-5"
                  style="border: 1px solid rgb(0 0 0 / 42%)"
                  v-model="idconsumidores"
                >
                </v-checkbox>
              </v-col>
            </v-row>
            <v-row justify="center" class="mb-1 mt-6">
              <v-col cols="4">
                <BaseButton
                  variant="import"
                  class="button rounded-pill"
                  @click="setOpenAddGuests"
                >
                  Cancelar
                </BaseButton>
              </v-col>
              <v-col cols="4">
                <BaseButton
                  variant="filter"
                  class="button rounded-pill"
                  type="submit"
                >
                  Enviar
                </BaseButton>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card>
    </v-dialog>
  </fragment>
</template>

<script>
import BaseTextarea from "@/components/forms/BaseTextarea.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "AddGuests",
  components: {
    BaseTextarea,
    BaseButton,
  },
  data() {
    return {
      convidados: "",
      idconsumidores: false,
    };
  },
  computed: {
    ...mapGetters(["AddGuests", "emailsOptions", "storeSequencial", "saveId"]),
  },
  methods: {
    ...mapActions([
      "setOpenAddGuests",
      "setEmails",
      "setSendGuest",
      "showSnackbarError",
    ]),
    async sendForm() {
      if (!this.$refs.form.validate()) {
        this.showSnackbarError("Preencha os campos obrigatórios!");
        return false;
      } else {
        try {
          const invites = this.convidados.split(/[;,]+/);
          let data = {
            loja: this.storeSequencial,
            idemail_marketing: this.saveId,
            envia_consumidores: this.idconsumidores,
            emails: invites == "" ? null : invites,
          };
          this.setSendGuest(data);
        } finally {
          (this.idconsumindores = false), (this.convidados = "");
        }
      }
    },
  },
  destroyed() {
    this.idconsumidores = false;
    this.convidados = "";
  },
};
</script>

<style lang="scss" scoped></style>
